export default {"src":"/_next/static/media/ArcBottomRightBrown.cd3fcedb.svg","height":8,"width":7,"blurWidth":0,"blurHeight":0};